export default {
    'upload-files': () => import("@/modules/projects/model/UploadContainers"),
    'view-component': () => import("@/modules/projects/model/ViewComponent"),
    'component-docs': () => import("@/modules/viewer/ComponentDocuments"),
}